module.exports = __webpack_public_path__ + "public/img/公共广播.8fa015eb.png";